import { motion } from "framer-motion";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

const PHONE_REGEX = /^[6-9]\d{9}$/;
const EMAIL_REGEX = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;

export const BusinessDetails = ({ data, setData, onNext, onBack }) => {
  const set = (key, value) => setData((d) => ({ ...d, [key]: value }));

  const handleNext = () => {
    const required = ["business_name", "category_of_product", "contact_person_name", "phone_number", "email", "city"];
    for (const key of required) {
      if (!data[key] || !String(data[key]).trim()) {
        toast.error("Please fill in all required fields.");
        return;
      }
    }
    if (!PHONE_REGEX.test(data.phone_number)) {
      toast.error("Enter a valid 10-digit mobile number.");
      return;
    }
    if (!EMAIL_REGEX.test(data.email)) {
      toast.error("Enter a valid email address.");
      return;
    }
    onNext();
  };

  return (
    <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }} data-testid="screen-3-business-details" className="max-w-2xl mx-auto">
      <h2 className="font-extrabold text-3xl sm:text-4xl text-center mb-2">Tell us about your business</h2>
      <p className="text-gray-500 text-center mb-10">A few details so we can get to know you.</p>

      <div className="space-y-5">
        <div>
          <Label>Business Name *</Label>
          <Input data-testid="input-business-name" value={data.business_name || ""} onChange={(e) => set("business_name", e.target.value)} className="mt-1.5 focus-visible:ring-[#D81B60]" />
        </div>
        <div className="grid sm:grid-cols-2 gap-5">
          <div>
            <Label>Category of Product *</Label>
            <Input data-testid="input-category" value={data.category_of_product || ""} onChange={(e) => set("category_of_product", e.target.value)} placeholder="e.g. Jewellery, Home Decor" className="mt-1.5 focus-visible:ring-[#D81B60]" />
          </div>
          <div>
            <Label>City *</Label>
            <Input data-testid="input-city" value={data.city || ""} onChange={(e) => set("city", e.target.value)} className="mt-1.5 focus-visible:ring-[#D81B60]" />
          </div>
        </div>
        <div className="grid sm:grid-cols-2 gap-5">
          <div>
            <Label>Contact Person Name *</Label>
            <Input data-testid="input-contact-person" value={data.contact_person_name || ""} onChange={(e) => set("contact_person_name", e.target.value)} className="mt-1.5 focus-visible:ring-[#D81B60]" />
          </div>
          <div>
            <Label>Phone Number *</Label>
            <Input
              data-testid="input-phone"
              value={data.phone_number || ""}
              onChange={(e) => set("phone_number", e.target.value.replace(/\D/g, "").slice(0, 10))}
              placeholder="10-digit mobile number"
              maxLength={10}
              inputMode="numeric"
              className="mt-1.5 focus-visible:ring-[#D81B60]"
            />
          </div>
        </div>
        <div className="grid sm:grid-cols-2 gap-5">
          <div>
            <Label>Email *</Label>
            <Input type="email" data-testid="input-email" value={data.email || ""} onChange={(e) => set("email", e.target.value)} className="mt-1.5 focus-visible:ring-[#D81B60]" />
          </div>
          <div>
            <Label>Instagram Handle</Label>
            <Input data-testid="input-instagram" value={data.instagram_handle || ""} onChange={(e) => set("instagram_handle", e.target.value)} placeholder="@yourbrand" className="mt-1.5 focus-visible:ring-[#D81B60]" />
          </div>
        </div>
      </div>

      <div className="flex justify-between gap-4 mt-10">
        <button onClick={onBack} data-testid="business-details-back-button" className="rounded-full border border-gray-300 px-6 py-3 text-sm">Back</button>
        <button onClick={handleNext} data-testid="business-details-continue-button" className="rounded-full bg-[#D81B60] text-white px-8 py-3 text-sm hover:bg-[#AD144B] transition-colors duration-300">
          Continue to Payment
        </button>
      </div>
    </motion.div>
  );
};
